const renderStrikedFxAndFee = (strikeFee, fee, strikeReceiveAmount, 
    receiveAmount, strikeFx, extraMoneyParent, differenceFeeParent, 
    strikeFxToText, strikeFxTo, receiverStrikedEl, feeElem, receiveAmountElem,currency, 
    sendToCurrency, sendAmount, extraMoneyEl, diffFeeEl, feeElemText,strikeFeeEl,currentFeeEl,strikedFeeToText, strikeFxFromText, fx, fee_percentage, feePercentageContainer) => 
{   
    const feeElemFirstPart = feeElemText && `${feeElemText.split(':')[0]}: `   
    let brandRefresh = feeElem?.getAttribute('data-brand-refresh');
    let isBrandRefresh = ((brandRefresh === '') || (brandRefresh === null) || (brandRefresh === undefined)) ? false :true; 
    if((!extraMoneyParent || !differenceFeeParent || !strikeFxToText || !strikeFxTo) && (!isBrandRefresh)) {
        return;
    }
    fee = fee?.toFixed(2)
    strikeFee = strikeFee?.toFixed(2)
    if(receiveAmount && strikeReceiveAmount  && (receiveAmount <= strikeReceiveAmount || fx <= strikeFx)) {
        strikeFxToText?.classList.add('d-none')
        strikeFxFromText?.classList.add('d-none')
        strikeFxTo?.classList.add('d-none')
        receiverStrikedEl?.classList.add('d-none')
        receiverStrikedEl && receiveAmountElem?.classList.add('p-4')
        toggleClass(extraMoneyParent,'d-flex' ,'d-none' )
    } else if(receiveAmount && strikeReceiveAmount && (receiveAmount > strikeReceiveAmount)) {
        toggleClass(extraMoneyParent,'d-none', 'd-flex' )
        strikeFxToText?.classList.remove('d-none')
        strikeFxFromText?.classList.remove('d-none')
        strikeFxTo?.classList.remove('d-none')
        receiverStrikedEl?.classList.remove('d-none')
        receiveAmountElem?.classList.remove('p-4')
    }

    if(strikeFee !== undefined && fee !== undefined && fee !== null && (strikeFee <= fee)) {
        feeElem.innerText = `${feeElemFirstPart} ${fee} ${currency}`
        toggleClass(differenceFeeParent,'d-flex','d-none')
        if((strikedFeeToText !== undefined) && (strikeFeeEl !== undefined)) {
            strikedFeeToText.classList.add('d-none')
            strikeFeeEl.classList.add('d-none')
        }            
    } else if(strikeFee !== undefined && fee !== undefined && strikeFee >= fee) {
        toggleClass(differenceFeeParent,'d-none','d-flex')
        if((strikedFeeToText !== undefined) && (strikeFeeEl !== undefined)) {
            strikedFeeToText.classList.remove('d-none')
            strikeFeeEl.classList.remove('d-none')
        }
        feeElem.innerHTML = feeElemText.replace('{{strikedFee}}', `<span class="font-body-xs font-weight-medium font-linethrough striked-fee text-red" style="text-decoration: line-through;">${strikeFee}</span>`)
        feeElem.innerHTML = feeElem.innerHTML.replace('{{strikedFeeNotRed}}', `<span class="font-body-xs font-weight-medium font-linethrough striked-fee text-grey-04" style="text-decoration: line-through;">${strikeFee} ${currency}</span>`)
        feeElem.innerHTML = feeElem.innerHTML.replace('{{fee}}', `<span class="fee font-body-xs font-weight-medium current-fee">${fee} ${currency}</span>`)
    }
    if(feePercentageContainer.length > 0) {
        Array.from(feePercentageContainer).forEach((feePercentage) => {
            if(fee_percentage !== undefined)
                feePercentage.textContent = `${fee_percentage}% off`;
            else
                toggleClass(feePercentage, 'd-flex', 'd-none');
        });
    }
    if(!receiveAmount) receiveAmount = 0.00
    if(strikeFx !== undefined) strikeReceiveAmount = (strikeFx*sendAmount)
    if(receiveAmount && strikeReceiveAmount && (receiveAmount >= strikeReceiveAmount)) {
        if(!strikedFeeToText) {
            if((extraMoneyEl !== null) && (extraMoneyEl)) extraMoneyEl.innerText = extraMoneyEl.innerText.replace('{{extraMoney}}',`${(receiveAmount - strikeReceiveAmount).toFixed(2)} ${sendToCurrency}`)
        } else {
            if((extraMoneyEl !== null) && (extraMoneyEl)) extraMoneyEl.innerText = extraMoneyEl.innerText.replace('{{extraMoney}}',`${sendToCurrency} ${(receiveAmount - strikeReceiveAmount).toFixed(2)}`)
        }
        extraMoneyEl && extraMoneyEl.classList.remove('d-none')
    }
    if((strikeFee !== undefined) && (strikeFee > 0) && (strikeFeeEl !== undefined))  strikeFeeEl.innerText = strikeFee;
    if((fee !== undefined) && (fee >= 0) && (fee !== null) && (currentFeeEl !== undefined)) currentFeeEl.innerText = `${fee} ${sendToCurrency}`

    if(strikeFx !== undefined && strikeFxTo !== null) {
        if(feeElemText.includes('{{strikedFeeNotRed}}')) {
            strikeFxTo.innerText = `${strikeFx} ${sendToCurrency}`
        } else {
            strikeFxTo.innerText = strikeFx
        }
    }
    if((strikeFee !== undefined) && (fee !== undefined) && (strikeFee >= fee) && (diffFeeEl)) {
        if(!strikedFeeToText) {
            diffFeeEl.innerText = diffFeeEl.innerText.replace('{{feeDifference}}',`${(strikeFee - fee).toFixed(2)} ${currency}`)
        } else {
            diffFeeEl.innerText = diffFeeEl.innerText.replace('{{feeDifference}}',`${currency} ${(strikeFee - fee).toFixed(2)}`)
        }
        diffFeeEl.classList.remove('d-none')
    }
    if((strikeFx !== undefined) && (receiverStrikedEl)) receiverStrikedEl.innerText = (strikeReceiveAmount).toFixed(2)
    if(strikeFx === undefined) {
        strikeFxToText?.classList.add('d-none')
        strikeFxFromText?.classList.add('d-none')
        strikeFxTo?.classList.add('d-none')
    }
    if(feeElem?.innerHTML?.includes('{{strikedFeeNotRed}}')) {
        feeElem.innerHTML = feeElem.innerHTML.replace('{{strikedFeeNotRed}}', ``)
    }
    if(feeElem?.innerHTML?.includes('{{fee}}')) {
        feeElem.innerHTML = feeElem.innerHTML.replace('{{fee}}:', ``)
    }
}

const resetStrikedFeeAndEl = (extraMoneyEl, extraMoneyInitValue,diffFeeEl, receiverStrikedEl, feeElem, extraMoneyParent, differenceFeeParent, diffFeeElInitValue, feeElemText, feeContainer) => {
    if(extraMoneyEl) {
        extraMoneyEl.innerText = extraMoneyInitValue
    }
    if(diffFeeEl) {
        diffFeeEl.innerText = diffFeeElInitValue
    }
    if(receiverStrikedEl) receiverStrikedEl.innerText = ''
    if(feeContainer) {
        toggleClass(feeContainer, 'd-flex','d-none');
    }
    feeElem.innerText = feeElemText
    if(extraMoneyParent){
        toggleClass(extraMoneyParent, 'd-flex','d-none');
    }
    if(differenceFeeParent) {
        toggleClass(differenceFeeParent, 'd-flex','d-none');
    }
}

const toggleClass = (el, classToRemove, classToAdd) => {
    if(!el) return;
    el.classList.remove(classToRemove);
    el.classList.add(classToAdd);
}

const toggleClasses = (el, classOne, classTwo, value) => {
    classOne && el.classList.toggle(classOne, value === null)
    classTwo && el.classList.toggle(classTwo, value !== null)
}
